"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMerchantInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_form_1 = require("@dzambalaorg/mui-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const SearchMerchantInput = (props) => {
    const name = "merchantId";
    const merchantId = (0, react_hook_form_1.useWatch)({ name });
    const { registeredInputs, unregisterInput } = (0, mui_form_1.useInputRegistry)();
    (0, react_1.useEffect)(() => {
        if (merchantId && registeredInputs.some(input => input.name === name)) {
            unregisterInput(name);
        }
    }, [merchantId, registeredInputs]);
    return (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: "merchants", ...props });
};
exports.SearchMerchantInput = SearchMerchantInput;
//# sourceMappingURL=index.js.map